import styled from '@emotion/styled';

export const Form = styled.form(`
  width: 95%;
  display: inline-flex;
  flex-wrap: wrap;
  justify-content: center;
`);